import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { release, buildStamp } from './version';
import { fetchBackendVersion } from './backendVersion';

/**
 * What this instance is running, where someone can read it out over the phone.
 *
 * Shows the front end's release. If the backend reports a different one the
 * badge says so — that is the failure lockstep versioning cannot otherwise
 * see, because each front end only ever asserts its own build.
 */
export default function ReleaseBadge() {
  const [backend, setBackend] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchBackendVersion().then((v) => { if (alive) setBackend(v); });
    return () => { alive = false; };
  }, []);

  const skewed = backend && backend.release && backend.release !== release;

  const detail = [
    `Front end ${release} (build ${buildStamp})`,
    backend ? `Backend ${backend.release}` : 'Backend version unavailable',
    backend && backend.schema != null ? `Schema ${backend.schema}` : null,
  ].filter(Boolean).join(' · ');

  return (
    <Tooltip title={detail}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 4, opacity: 0.6 }}>
        {skewed && <WarningAmberIcon sx={{ fontSize: 14 }} color="warning" />}
        <Typography variant="caption" color={skewed ? 'warning.main' : 'text.secondary'}>
          {skewed
            ? `Greaterbase ${release} / backend ${backend.release}`
            : `Greaterbase ${release}`}
          {backend && backend.schema != null ? ` · schema ${backend.schema}` : ''}
        </Typography>
      </Box>
    </Tooltip>
  );
}
